import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Factory for translate files
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
